import { Typography } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../types/store';
import AppConstants from '../constants/app-constants';
type UITimerStyleProps = {
    height?: number;
    parentBackgroundColor?: string;
    parentWidth?: string;
    borderRadius?: number;
};
type UITimerProps = {
    seconds: number;
    reset?: boolean;
    reverse?: boolean;
    message?: string;
    onClick?: () => void;
    styles?: UITimerStyleProps;
};

const TICKDELAY = 100;
export default function UITimer({ seconds, reset, reverse, message, onClick, styles = { height: 50, parentBackgroundColor: "transparent", parentWidth: "100%", borderRadius: 5 } }: UITimerProps) {
    const [current, setCurrent] = useState(seconds * 10);
    const [start, setStart] = useState(seconds * 10);
    const timerRef = useRef<number | null>(null);
    const prevResetRef = useRef(reset);
    const prevSecondsRef = useRef(seconds);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 'sm' = small devices
    const lobby = useSelector((state: RootState) => state.page.lobby)
    const stopTimer = () => {
        if (timerRef.current !== null) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    };

    useEffect(() => {
        timerRef.current = window.setInterval(() => {
            setCurrent(prev => {
                if (prev <= 0) {
                    stopTimer();
                    return 0;
                }
                return prev - 1;
            });
        }, TICKDELAY);

        return () => {
            stopTimer();
        };
    }, []);

    useEffect(() => {
        if (reset && reset !== prevResetRef.current) {
            stopTimer();
            const newStart = seconds * 10;
            setStart(newStart);
            setCurrent(newStart);
            timerRef.current = window.setInterval(() => {
                setCurrent(prev => {
                    if (prev <= 0) {
                        stopTimer();
                        return 0;
                    }
                    return prev - 1;
                });
            }, TICKDELAY);
        }
        prevResetRef.current = reset;
    }, [reset, seconds]);

    useEffect(() => {
        if (seconds !== prevSecondsRef.current) {
            setCurrent(seconds * 10); // Update current only, not start
        }
        prevSecondsRef.current = seconds;
    }, [seconds]);

    let proc_left = ((current / start) * 100);
    if (reverse) {
        proc_left = 100 - proc_left;
    }

    //const progressColorSmooth = `linear-gradient(to right, green 0%, yellow ${proc_left}%, red 100%)`;

    let backgroundColor = "#346f34";
    if (!reverse) {
        if (proc_left <= 25) backgroundColor = "red";
        else if (proc_left <= 50) backgroundColor = "orange";
        else if (proc_left <= 75) backgroundColor = "yellow";
        //if (proc_left === 100) backgroundColor = "timer-90 no-animation";
    }

    let outMessage: React.JSX.Element = <></>;
    if (message && message.length > 0) {
        outMessage = isMobile ? <Typography fontSize={"0.5em"} color="#ffffffff" zIndex={4}>{message}</Typography>
            : <Typography fontSize={"1.0em"} fontWeight={600} color="#ffffffff" zIndex={4}>{message}</Typography>
    }
    let pos: any = lobby.state === AppConstants.STATE_QUESTION && !lobby.playing ? 'absolute' : 'relative'
    return (
        <div style={{ width: styles.parentWidth, position: pos, zIndex: 10, textAlign: 'center', display: "flex", flexDirection: "column", alignItems: "center", justifyContent: 'center' }}
            onClick={onClick}>
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '4px', zIndex: 9999, backgroundColor: styles.parentBackgroundColor }}>
                <div style={{ lineHeight: `4px`, width: proc_left + "%", height: `4px`, background: backgroundColor, transition: 'background-color 1s ease, width 0.1s linear' }}>
                </div>
            </div>
            {outMessage}
        </div>
    );
}